
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/reviews",
      function () {
        return require("private-next-pages/reviews.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/reviews"])
      });
    }
  